export function openExternalLink(url: string, openInNewTab = true): void {
  const link = document.createElement('a');
  link.href = url;
  if (openInNewTab) {
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
  }
  link.click();
}

export function normalizeNavigateUrl(url: string): string {
  return url.startsWith('/') || url.includes('://') ? url : `https://${url}`;
}

export function isSameOriginUrl(url: string): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return new URL(url, window.location.href).origin === window.location.origin;
  } catch {
    return false;
  }
}
